import { defineComponent as _defineComponent } from 'vue'


type Props = {
  resource: string;
  refData: string;
  itemId: string;
  title: string;
};

type Filters = { [key: string]: { [filterBy: string]: string } };
type Fields = { [key: string]: { [key: string]: string }[] };


export default /*#__PURE__*/_defineComponent({
  __name: 'RefDataResourcesTable',
  props: {
    resource: null,
    refData: null,
    itemId: null,
    title: null
  },
  setup(__props: any) {

const props = __props as {
  resource: string;
  refData: string;
  itemId: string;
  title: string;
}



const filters: Filters = {
  series: {
    'serie.id': props.itemId,
  },
  categories: {
    categories: props.itemId,
  },
};

const resourceFields: Fields = {
  books: [
    {
      source: 'isbn',
      link: 'show',
    },
    {
      source: 'title',
    },
  ],
};

const filter = filters[props.refData];
const fields = resourceFields[props.resource];

return { __sfc: true,props, filters, resourceFields, filter, fields }
}

})